const TableSkeleton = ({ rows = 5 }: { rows?: number }) => {
    return (
        <div className="animate-pulse">
            {/* Header skeleton */}
            <div className="bg-gray-50 dark:bg-slate-700 border-b border-gray-200 dark:border-slate-600">
                <div className="grid grid-cols-7 gap-4 px-6 py-3">
                    {Array.from({ length: 7 }).map((_, i) => (
                        <div key={i} className="h-4 bg-gray-300 dark:bg-slate-600 rounded"></div>
                    ))}
                </div>
            </div>
            
            {/* Rows skeleton */}
            {Array.from({ length: rows }).map((_, i) => (
                <div key={i} className="border-b border-gray-200 dark:border-slate-700">
                    <div className="grid grid-cols-7 gap-4 px-6 py-4">
                        {Array.from({ length: 7 }).map((_, j) => (
                            <div key={j} className="h-4 bg-gray-200 dark:bg-slate-700 rounded"></div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default TableSkeleton;
